import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { OrderSummaryData } from '../../../../../../models/order/workflow/order-summary.model';


@Injectable({ providedIn: 'root' })
export class OrderSummaryStateService extends BaseWorkflowStateService<OrderSummaryData> {
    override stateKey: string = 'orderSummary';
}